// import universal from 'react-universal-component'
//
// const component = universal(props => import('./CreatePage.js'))
//
// const AsyncCreatePage = {
//   title: 'compose.new.page_title', // i18n key
//   getInitialProps: async (dispatch, getState, opts) => {},
//   getComponent: () => {
//     return component
//   }
// }

import AsyncPage from 'pages/AsyncPage'
import universal from 'react-universal-component'

const pageComponent = universal(props =>
  import('pages/create/choose/CreatePage')
)

export default new AsyncPage({
  title: 'compose.new.page_title',
  pageComponent
})
